import React,{memo} from 'react';
import {Button as ButtonComp} from "react-bootstrap";
import { SaveButton, ButtonGroup as ButtonGroupComp, BoxButton as BoxBtnComp} from '@idexcel-technologies-pvt-ltd/cync-los-common-components';
export default memo((props) => (<SaveButton  {...props}/>));
export const Button = memo((props) => (<ButtonComp  {...props}/>));
export const ButtonGroup = memo((props) => (<ButtonGroupComp  {...props}/>));
export const BoxButton = memo((props) => (<BoxBtnComp  {...props}/>));
